<template>
  <div class="good-item">
    <div class="pic"><img v-lazy="getImageUrl(data.itemImageUrl, '?imageView2/1/w/128/h/128', './static/img/goods_default.png')" /></div>
    <div class="content">
      <h3 class="title">{{data.itemName}}</h3>
      <div class="time" v-if="showTime">{{data.itemSkuSubject}}</div>
      <div class="main">
        <p class="price" v-html="getPriceCreditHtml(data.itemPrice, data.itemCreditPrice)"></p>
        <p class="quantity">x{{data.itemCount}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { getImageUrl, getPriceCreditHtml } from '@/utils/utils'
export default {
  name: 'GoodItem',
  props: {
    data: { type: Object, required: true },
    showTime: { type: Boolean, default: false }
  },
  methods: { getImageUrl, getPriceCreditHtml }
}
</script>
